/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AuthStore, AuthData } from 'modules/common/PortfolioManager/types';

const baseApiUrl = process.env.REACT_APP_API_TARGET || window.location.origin;
const navigatorApiUrl = '/navigator/api/v1';

type NavigatorToken = {
  role: 'access_denied' | string;
};

const useNavigatorPost = <T = void>(path: string): (() => Promise<T>) => {
  const { token } = useSelector<AuthStore, AuthData>(({ auth }) => auth.data);

  return () =>
    fetch(`${baseApiUrl}${navigatorApiUrl}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ${token}`,
      },
    }).then((res) => res.json());
};

export const useGetNavigatorAccess = () => {
  const [hasAccess, setAccess] = useState(false);
  const getAccess = useNavigatorPost<NavigatorToken>('/token/');

  useEffect(() => {
    getAccess().then(({ role }) => setAccess(role !== 'access_denied'));
  }, []);

  return hasAccess;
};

export const useRequestNavigatorAccess = () => useNavigatorPost('/request_access/');
